import React from 'react';
import { useParams } from 'react-router';

import { useQuiz } from './useQuiz';
import { Jessica } from '../../app';
import { PageLayout } from '../../app/Layouts';
import { QuizComponent } from './QuizComponent';
import { getCourseLanguage } from '../../utilities';
import { Breadcrumbs, DynamicPageTitle } from '../../components';

type QuizPageProps = {};

const QuizPage: React.FC<QuizPageProps> = () => {
  const { enrollmentId, stepId } = useParams<{
    enrollmentId: string;
    stepId: string;
  }>();
  const { loading, quiz, course, courseStep, enrollment, ...rest } = useQuiz(
    enrollmentId,
    stepId
  );

  if (loading || !enrollment || !course || !courseStep) return null;

  return (
    <PageLayout
      subheaderContent={
        <div className="border-b w-full">
          <DynamicPageTitle>Quiz</DynamicPageTitle>
          <div className="m-5">
            <Breadcrumbs
              subtitle="Course"
              subtitleUrl={`/courses/${enrollmentId}`}
              title={courseStep?.title ?? 'Quiz Name'}
            />
          </div>
        </div>
      }
    >
      <QuizComponent
        {...rest}
        stepId={stepId}
        loading={loading}
        courseStep={courseStep}
        quiz={quiz}
        course={course}
        enrollment={enrollment}
        jessica={
          <Jessica
            enrollmentId={enrollment.id}
            language={getCourseLanguage(course)}
            agentId={courseStep?.agentId || course?.agentId}
          />
        }
      />
    </PageLayout>
  );
};

export default QuizPage;
